<template>
  <div>
    <CruiseSlideCard
      v-for="(cruise, index) in cruiseData"
      :key="index"
      ref="cruiseSlideCard"
      :card-data="cruise"
      :cruise-index="index"
      :is-card-active="activeClass(index)"
      :showTime="true"
      :text-labels="textLabels"
      @click="chooseCruise(index)"
    />
  </div>
</template>

<script>
import CruiseSlideCard from "@/stories/Components/CruiseItineraryDetail/Elements/CruiseSlideCard/CruiseSlideCard";

export default {
  name: "CruiseSliderMobile",
  components: {
    CruiseSlideCard,
  },
  props: {
    cruiseData: {
      type: Array,
      required: true,
    },
    textLabels: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      chosenCruiseIndex: 0,
    };
  },
  methods: {
    activeClass(index) {
      return this.chosenCruiseIndex === index;
    },
    chooseCruise(cruiseIndex) {
      this.chosenCruiseIndex = cruiseIndex;
      this.$emit("change-cruise-index", cruiseIndex);
    },
  },
};
</script>
